export default __webpack_public_path__ + "static/media/dog-paw-svgrepo-com.d6a69466.svg";